import { useCallback } from 'react';
import { useUserStore } from '../../../store/userStore';
import { keycloak } from '../../../auth/keycloak';
import { useGetCurrentUserApiV1UsersMeGet } from '@/services/api/user/user';

export const useUserInfo = () => {
  const { user, isLoading, error, setUser, setLoading, setError, clearUser } = useUserStore();

  const { refetch } = useGetCurrentUserApiV1UsersMeGet({
    query: {
      enabled: false,
      retry: 1,
      retryDelay: 1000,
    },
  });

  const fetchUserInfo = useCallback(async () => {
    if (!keycloak.authenticated || !keycloak.token) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const result = await refetch();

      if (result.data) {
        setUser(result.data);
      } else {
        setError('No user data received');
      }
    } catch {
      setError('Failed to fetch user information');
    } finally {
      setLoading(false);
    }
  }, [refetch, setUser, setLoading, setError]);

  const clearUserInfo = useCallback(() => {
    clearUser();
  }, [clearUser]);

  return {
    user,
    isLoading,
    error,
    fetchUserInfo,
    clearUserInfo,
  };
};
